import { CLEAR_RESPONSE, RESPONSE_STATUS, GET_LINKED_USER_DETAILS } from './linkedinType'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_LINKED_USER_DETAILS:
            return {
                ...state,
                linkedUserDetails: action.payload,
            }

        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
